import { COMPLAINTS_COMPLAINT_ACTIVITES_LOADING, COMPLAINTS_COMPLAINT_ACTIVITES_LOADED, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_ATTACH_EMAIL_SUBMITTING, } from "../actions";
const initialState = {
    loadingState: "NOT_LOADED",
    requestedState: { page: 0, flagged: false, outcomeDocsOnly: false },
    caseId: undefined,
    data: [],
};
export const activities = (state = Object.assign({}, initialState), { type, payload }) => {
    switch (type) {
        case COMPLAINTS_COMPLAINT_ACTIVITES_LOADING:
        case COMPLAINTS_NEW_COMPLAINT_ACTIVITY_ATTACH_EMAIL_SUBMITTING:
            // note email attaching can be long running, so preemptively start the loading spinner to reassure the user
            return Object.assign(Object.assign({}, state), { loadingState: "LOADING" });
        case COMPLAINTS_COMPLAINT_ACTIVITES_LOADED:
            return Object.assign(Object.assign({}, state), { loadingState: "LOADED", data: payload.data, requestedState: payload.requestState, caseId: payload.caseId });
        default:
            return state;
    }
};
